/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Text, Theme, useTheme } from 'bold-ui'

export default function HistoricoInfoAdminPanel(props) {
  const theme = useTheme()
  const classes = styles(theme)

  return (
    <div css={classes.container}>
      <Grid gapVertical={0.5}>
        <Cell size={12}>
          <Heading level={3}>Informações administrativas</Heading>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Profissional responsável:</Text>
            <Text>Ana Luiza de Paula Fernandez - Cirurgião Dentista | Equipe 00003485674 - ENI</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontStyle='italic'>Registro tardio registrado em [data] às [hora]</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Local de atendimento:</Text>
            <Text>Unidade Córrego Grande</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>CNES:</Text>
            <Text>Nome do estabelecimento + CNES</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Atendimento compartilhado:</Text>
            <Text>-</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Cuidador:</Text>
            <Text>[CNS] - [TIPO SELECIONADO]</Text>
          </HFlow>
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Local de atividade:</Text>
            <Text>Número INEP [Código]</Text>
          </HFlow>
        </Cell>
      </Grid>
    </div>
  )
}

const styles = (theme: Theme) => ({
  container: css`
    border-top: 1px solid ${theme.pallete.divider};
    padding: 1rem;
  `,
})
